// extracted by mini-css-extract-plugin
export default {"documents":"Documents_documents__9gyvT","empty":"Documents_empty__y-Hqk","header":"Documents_header__ojQuC","content":"Documents_content__c+KoL","nav":"Documents_nav__lMTDX"};